import Details from "./details"

export default Details
